import React from 'react';
import { Icon, ButtonSecondary } from '@common-web';
import { Flex } from 'antd';
import { Link } from 'react-router-dom';

const Actions = ({ actions = [], gap = 6 }) => {
  const filteredActions = actions?.filter((item) => !!item?.show);
  return (
    <Flex vertical gap={gap} align="start">
      {filteredActions?.map(
        ({ onClick = () => { }, value = '', isLink = false, path = '', icon, target = '_self', disabled, state = {}, loading = false }, index) =>
          isLink ? (
            <Link state={state} to={path} className="flex flexYcenter gap-4 fw-600" key={String(index)} target={target}>
              <Icon icon={icon} hasBackground iconSize={'1em'} bgSize="1.5em" color={'currentColor'} />
              <span>{value}</span>
            </Link>
          ) : (
            <ButtonSecondary
              text={value}
              icon={icon}
              iconHasBackground
              iconSize={'1em'}
              iconBgSize="1.5em"
              iconColor={'currentColor'}
              key={index}
              onClick={(e) => {
                e.stopPropagation();
                onClick()
              }}
              type="link"
              disabled={disabled}
              loading={loading}
            />
          )
      )}
    </Flex>
  );
};

export default Actions;
